var map = {
	"./affinity-water.png": 7427,
	"./amazon.png": 1353,
	"./bp.png": 2464,
	"./britvic.png": 674,
	"./carnation.png": 6597,
	"./cpw.png": 8610,
	"./disaronno.png": 2263,
	"./ena.png": 5053,
	"./fenco-x.png": 9377,
	"./ferrero.png": 5290,
	"./graze.png": 5454,
	"./hasbro.png": 4208,
	"./hinge.png": 5718,
	"./maggi-1.png": 8460,
	"./man-city.png": 6931,
	"./mccoll-s.png": 7957,
	"./nestle-professional.png": 1215,
	"./nestle.png": 491,
	"./netflix.png": 7140,
	"./nothing-logo.png": 8659,
	"./purina.png": 6827,
	"./redbull.png": 3694,
	"./s-pellegrino.png": 3471,
	"./simply-cook.png": 928,
	"./simply-health.png": 761,
	"./starbucks.png": 1428,
	"./ted-baker.png": 2869,
	"./the-botanist.png": 3813,
	"./tia-maria.png": 2237,
	"./tui.png": 7713,
	"./universal.png": 762,
	"./vitality.png": 5613,
	"./warner-bros.png": 6673,
	"./west-berkinshire-brewery.png": 6519
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 9694;